import { FC } from 'react';

import Helmet from 'react-helmet';
import { Route, RouteComponentProps } from 'react-router-dom';
import PublicLayout from './Layout';

import { IRouteInterface } from 'src/interfaces/IRoutes';

const Public: FC<IRouteInterface> = ({
  component: Component,
  title,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(props: RouteComponentProps) => (
        <>
          <Helmet>
            <title>{title}</title>
          </Helmet>
          <PublicLayout>
            <Component {...props} />
          </PublicLayout>
        </>
      )}
    />
  );
};

export default Public;
